import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs/internal/Subscription';
import {ActivatedRoute, Router} from '@angular/router';
import {UserService} from "../../modules/user/user.service";
import {timer} from "rxjs/internal/observable/timer";
import {PeriodicRefreshService} from "../../modules/utility/periodic-refresh.service";
import {PortalApiService} from "../../modules/record/portal-api.service";
import {ConfigService} from "../../modules/base/config.service";
import {AppConfig} from "../../modules/base/app-config";
import {UserInfo} from "../../modules/user/user-models";

@Component({
  selector: 'ae-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss']
})
export class NavComponent implements OnInit, OnDestroy {

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private userSvc: UserService,
    private apiService: PortalApiService,
    private refreshSvc: PeriodicRefreshService,
    private config: ConfigService<AppConfig>,
  ) {
  }

  now = new Date();
  private clockSub: Subscription | null = null;
  private isAdminSub: Subscription | null = null;
  private isViewerSub: Subscription | null = null;
  private isSuperUserSub: Subscription | null = null;
  private refreshSub: Subscription | null = null;
  isSuperuser = false;
  canManage = false;
  canView = false;
  lastRefreshed!: Date;

  customer:string = "";
  currentUser: UserInfo | null = null;

  ngOnInit(): void {
    this.customer = this.config.getConfig().customerName;

    this.userSvc.currentUser().subscribe(user => {
      this.currentUser = user;
      this.isSuperuser = user.superuser;
    });

    this.isAdminSub = this.userSvc.isAdmin().subscribe(it => {
      this.canManage = it;
    });
    this.isViewerSub = this.userSvc.isViewer().subscribe(it => {
      this.canView = it;
    });
    this.clockSub = timer(1, 1000).subscribe(() => {
      this.now = new Date();
    });
    this.refreshSub = this.refreshSvc.getLastRefreshed().subscribe(refreshed => {
      this.lastRefreshed = refreshed;
    });

    //to make sure at least once after refreshing we initiate currentUser check to determine if user is an admin
    timer(1).subscribe(() => {
      this.userSvc.currentUser().subscribe(user => {
        this.currentUser = user;
      });
    });
  }

  ngOnDestroy(): void {
    if (this.clockSub) {
      this.clockSub.unsubscribe();
      this.clockSub = null;
    }

    if (this.isAdminSub) {
      this.isAdminSub.unsubscribe();
      this.isAdminSub = null;
    }

    if (this.isViewerSub) {
      this.isViewerSub.unsubscribe();
      this.isViewerSub = null;
    }

    if (this.refreshSub) {
      this.refreshSub.unsubscribe();
      this.refreshSub = null;
    }
  }

  goto(url: string): void {
    this.router.navigate([url]);
  }

}
